import React, { useState } from 'react';
import InfoBadge from './InfoBadge';

export default function CollapsibleSection({
  title,
  icon,
  badge,
  tooltip,
  defaultOpen = false,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`glass-card overflow-hidden ${className}`}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="w-full flex items-center justify-between p-5 text-left"
      >
        <div className="flex items-center gap-2">
          {icon}
          <h3 className="text-lg font-semibold text-white">{title}</h3>
          {tooltip && <InfoBadge text={tooltip} position="top" />}
          {badge && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-dark-surface border border-dark-border text-gray-400">
              {badge}
            </span>
          )}
        </div>
        <svg
          className={`w-5 h-5 text-gray-400 transition-transform duration-200 flex-shrink-0 ${open ? 'rotate-180' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>
      {open && (
        <div className="px-5 pb-5 border-t border-dark-border/30 pt-4">
          {children}
        </div>
      )}
    </div>
  );
}
